import { render, staticRenderFns } from "./crm-group-meta-data.vue?vue&type=template&id=3ba9b3fc&scoped=true&"
import script from "./crm-group-meta-data.vue?vue&type=script&lang=js&"
export * from "./crm-group-meta-data.vue?vue&type=script&lang=js&"
import style0 from "./crm-group-meta-data.vue?vue&type=style&index=0&id=3ba9b3fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9b3fc",
  null
  
)

export default component.exports